import accountService from "../services/account.service";

const readData = (resp) => resp?.data?.data || resp?.data || null;

const readMessage = (resp, fallback) =>
  resp?.data?.data?.error ||
  resp?.data?.error ||
  resp?.data?.message ||
  fallback;

/** GET /account */
export const getAccount = () => async () => {
  try {
    const resp = await accountService.getAccount();

    if (resp?.status === 200) {
      return { success: true, response: resp, account: readData(resp) };
    }

    return {
      success: false,
      response: resp,
      message: readMessage(resp, "We couldn't load your account settings."),
    };
  } catch (error) {
    return {
      success: false,
      message: error?.message || "We couldn't load your account settings.",
    };
  }
};

/** PATCH /account */
export const updateAccount = (payload) => async () => {
  try {
    const resp = await accountService.updateAccount(payload);

    if (resp?.status === 200 || resp?.status === 204) {
      return { success: true, response: resp, account: readData(resp) };
    }

    return {
      success: false,
      response: resp,
      message: readMessage(resp, "We couldn't save your changes."),
    };
  } catch (error) {
    return {
      success: false,
      message: error?.message || "We couldn't save your changes.",
    };
  }
};

/** GET /account/usage - used vs limit for each metered resource. */
export const getAccountUsage = () => async () => {
  try {
    const resp = await accountService.getUsage();

    if (resp?.status === 200) {
      return { success: true, response: resp, usage: readData(resp) };
    }

    return {
      success: false,
      response: resp,
      message: readMessage(resp, "We couldn't load your usage."),
    };
  } catch (error) {
    return {
      success: false,
      message: error?.message || "We couldn't load your usage.",
    };
  }
};
